import { useLocation } from "react-router-dom";
import { CheckCircle2, ShieldCheck, Building2, User } from "lucide-react";

const ResellerInviteConnected = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const orgName = searchParams.get("org") || "Your Organisation";
  const resellerName = searchParams.get("reseller") || "Your Reseller";

  return (
    <div className="min-h-screen bg-gradient-to-b from-green-50/40 via-white to-gray-50 flex flex-col justify-between py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-lg mx-auto w-full">
        {/* Brand Header */}
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-14 h-14 rounded-2xl bg-blue-600 text-white shadow-lg shadow-blue-500/30 mb-4">
            <ShieldCheck className="w-8 h-8" />
          </div>
          <h2 className="text-2xl font-bold tracking-tight text-gray-900">
            WOW Backup & Restore
          </h2>
        </div>

        {/* Success Card */}
        <div className="bg-white rounded-2xl shadow-xl border border-gray-100 p-8 sm:p-10 text-center">
          <div className="w-16 h-16 rounded-full bg-green-100 text-green-600 mx-auto flex items-center justify-center mb-6 shadow-sm">
            <CheckCircle2 className="w-10 h-10" />
          </div>

          <h3 className="text-xl font-bold text-gray-900 mb-2">
            Organisation Connected Successfully!
          </h3>

          <p className="text-sm text-gray-600 mb-6 leading-relaxed">
            Your organization has been securely connected. Your reseller partner will now manage your automated backups, disaster recovery, and cloud archives.
          </p>

          {/* Details summary */}
          <div className="bg-gray-50 rounded-xl p-4 border border-gray-100 mb-8 text-left space-y-3">
            <div className="flex items-center gap-3">
              <Building2 className="w-5 h-5 text-gray-400 shrink-0" />
              <div>
                <span className="text-xs text-gray-400 uppercase tracking-wider block">Connected Organisation</span>
                <span className="text-sm font-semibold text-gray-900">{orgName}</span>
              </div>
            </div>
            <div className="flex items-center gap-3 border-t border-gray-200/60 pt-3">
              <User className="w-5 h-5 text-gray-400 shrink-0" />
              <div>
                <span className="text-xs text-gray-400 uppercase tracking-wider block">Managing Partner</span>
                <span className="text-sm font-semibold text-gray-900">{resellerName}</span>
              </div>
            </div>
          </div>

          <div className="bg-emerald-50 border border-emerald-100 rounded-xl p-3.5 text-xs text-emerald-800 font-medium">
            ✓ No further action is required from you. You may safely close this browser window.
          </div>
        </div>
      </div>

      {/* Footer */}
      <div className="text-center mt-8 text-xs text-gray-400">
        &copy; {new Date().getFullYear()} WOW Backup &amp; Restore. All rights reserved.
      </div>
    </div>
  );
};

export default ResellerInviteConnected;
